import React from 'react';
import { cn } from '@/utils/common-helpers';
import Image from 'next/image';

export function FeaturesSectionWithHoverEffects() {
    const features = [
        {
            title: 'Thousands of libraries',
            description:
                'Access a vast range of open-source libraries via Node.js package management (npm) for faster, more efficient development.',
            icon: '/img/technology/ic-thousand-lbraries.svg',
        },
        {
            title: 'Inexpensive Development Cycle',
            description:
                'Node.js offers rich features that help achieve large-scale projects with minimal resources, reducing the overall development cost.',
            icon: '/img/technology/ic-development-cycle.svg',
        },
        {
            title: 'Faster Development Process',
            description:
                'Node.js reduces the development time, allowing businesses to accelerate their time to market with efficient Node.js web application development.',
            icon: '/img/technology/ic-faster-development-process.svg',
        },
        {
            title: 'Robust Client-App Communication',
            description:
                "Node.js'snon-blocking, event-driven architecture ensures it can handle simultaneous client requests, making it ideal for chatbot development and real-time applications.",
            icon: '/img/technology/ic-client-communication.svg',
        },
        {
            title: 'Front & Back-End Development',
            description:
                'Use JavaScript for both front-end and back-end development with Node.js, ensuring a seamless development process.',
            icon: '/img/technology/ic-webapp.svg',
        },
        {
            title: 'Highly Scalable',
            description:
                'Node.js is built to manage heavy application loads, making it an excellent choice for building scalable web applications for enterprises.',
            icon: '/img/technology/ic-scalability.svg',
        },
        {
            title: 'Improved Productivity',
            description:
                'The combination of faster development, scalability, and a rich development environment improves overall productivity.',
            icon: '/img/technology/ic-improved-productivity.svg',
        },
        {
            title: 'Highly Secured',
            description:
                'Node.js is designed with robust security features, ensuring your applications are secure from vulnerabilities.',
            icon: '/img/technology/ic-highly-secured.svg',
        },
    ];
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  relative z-10 max-w-7xl mx-auto">
            {features.map((feature, index) => (
                <Feature key={feature.title} {...feature} index={index} total={features.length} />
            ))}
        </div>
    );
}

const Feature = ({
    title,
    description,
    icon,
    index,
    total,
}: {
    title: string;
    description: string;
    icon: string;
    index: number;
    total: number;
}) => {
    return (
        <div
            className={cn(
                'flex flex-col py-[30px] relative group/feature dark:border-neutral-800',
                index % 3 === 0 && 'lg:border-l dark:border-neutral-800',
                (index + 1) % 3 !== 0 && 'lg:border-r dark:border-neutral-800',
                index >= 3 && 'lg:border-t dark:border-neutral-800 ',
                index === 5 && 'lg:border-b dark:border-neutral-800 ',
                index === 5 && total % 2 === 0 && 'mb-[-1.2px]',
            )}
        >
            {index < 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            {index >= 3 && (
                <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
            )}
            <div className="mb-[10px] relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
                <Image src={icon} width={36} height={36} alt={title} title={title} className="" />
            </div>
            <div className="text-2xl font-bold mb-[10px] relative z-10 px-[30px]">
                <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-primary transition-all duration-200 origin-center" />
                <span className="group-hover/feature:translate-x-2 group-hover/feature:text-primary transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
                    {title}
                </span>
            </div>
            <p className="text-[#4C5773] mb-0 text-base text-neutral-600 dark:text-neutral-300 relative z-10 px-[30px]">
                {description}
            </p>
        </div>
    );
};
